import { Checkbox } from 'carbon-components-react';
import clsx from 'clsx';
import { PageSection } from 'components/common';
import icon from 'img/referrals.svg';
import { useFormContext } from 'react-hook-form';
import styles from './Programs.module.scss';

const Programs = ({ namespace, formDisabled }) => {
    const { getValues, setValue, register } = useFormContext();

    const programValues = getValues(namespace);

    const agentMatchProgramKey = PROGRAM_KEYS.AGENT_MATCH_2024;
    const agentMatchProgramCheckbox = register(`${namespace}.${agentMatchProgramKey}`, {
        value: !!programValues?.agentMatchProgramKey ? 1 : 0
    });

    return (
        <PageSection className={styles.programPageSection} name="Programs" icon={icon}>
            <div className="bx--grid bx--grid--full-width bx--no-gutter">
                <Checkbox
                    name={agentMatchProgramKey}
                    ref={agentMatchProgramCheckbox.ref}
                    id={agentMatchProgramCheckbox.name}
                    labelText={
                        <>
                            {PROGRAMS[agentMatchProgramKey].label}
                            <p className={clsx(styles.programDescription, 'bx--form__helper-text')}>
                                {PROGRAMS[agentMatchProgramKey].description}
                            </p>
                        </>
                    }
                    onChange={(checked) => {
                        setValue(`${namespace}.${agentMatchProgramKey}`, checked ? 1 : 0);
                    }}
                    disabled={formDisabled}
                />
            </div>
        </PageSection>
    );
};

const PROGRAM_KEYS = {
    AGENT_MATCH_2024: 'agentMatch_2024'
};

const PROGRAMS = {
    [PROGRAM_KEYS.AGENT_MATCH_2024]: {
        label: 'MediaAlpha Discount Program',
        description: (
            <>
                A 50% discount will be applied to every lead purchased until promotional balance funds are used in full.
                Promotional funds are only valid for 90 days after account activation.{' '}
                <strong>
                    Promotional balances are only based on initial deposit amounts and have a maximum discount total of
                    $1,000.
                </strong>
            </>
        ),
        agentDescription: (
            <>
                A 50% discount will be applied to every lead purchased until promotional balance funds are used in full.
            </>
        ),
        terms: (
            <>
                A 50% discount will be applied to every lead purchased until promotional balance funds are used in full.
                Promotional funds are only valid for 90 days after account activation.{' '}
                <strong>
                    Promotional balances are only based on your initial deposit amount and have a maximum discount total
                    of $1,000.
                </strong>
            </>
        )
    }
};

export { PROGRAM_KEYS, Programs, PROGRAMS };
